import type { AccessConstraint } from '@sb/shared/access';
import { PlanType } from '@shiftbase-com/ts-shared/models';

/** Access constraints for the insights routes. */
export const insightsAccess = {
  insights: { permission: ['View log'], subscriptionPlan: PlanType.BASIC },
} satisfies Record<string, AccessConstraint>;
